module.exports = __webpack_public_path__ + "files/7fb5842141d179c4a76200b61a29f959.png";